import React from 'react';
import Coordinates from '../data/common/Coordinates';
import PuzzleCell from './PuzzleCell';

/**
 * @param {PuzzleRowArgs} param0 
 */
const PuzzleRow = ({index, row, puzzleDefinition, onCellClick}) => {
    return (
        <div className="puzzle-row">
            {row.map((cell, cellIndex) =>
                <PuzzleCell
                    key={cellIndex}
                    cell={cell}
                    coordinates={new Coordinates({x: cellIndex, y: index})}
                    puzzleDefinition={puzzleDefinition}
                    onClick={onCellClick}
                />
            )}
        </div>
    )
}

export default PuzzleRow;
